import { render } from "./demoPieChart.vue?vue&type=template&id=fb5a56a8&scoped=true"
import script from "./demoPieChart.vue?vue&type=script&lang=js"
export * from "./demoPieChart.vue?vue&type=script&lang=js"

import "./demoPieChart.vue?vue&type=style&index=0&id=fb5a56a8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb5a56a8"]])

export default __exports__